"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import cn from "@/app/utils/cn";
export type ScrollSwitchTabItem = {
  key: string;
  label: React.ReactNode;
  disabled?: boolean;
  className?: string;
  badge?: React.ReactNode;
};
type ScrollSwitchTabProps = {
  items: ScrollSwitchTabItem[];
  activeKey: string;
  onChange: (key: string) => void;
  className?: string;
  fullWidth?: boolean;
  /** Overrides the label typography, e.g. "text-base md:text-base" */
  textClassName?: string;
};
export default function ScrollSwitchTab(t0) {
  const $ = _c(15);
  const {
    items,
    activeKey,
    onChange,
    className,
    fullWidth: t1,
    textClassName
  } = t0;
  const fullWidth = t1 === undefined ? false : t1;
  const t2 = fullWidth ? "justify-between" : "justify-start";
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn("no-scrollbar flex h-14 w-full flex-nowrap items-center gap-x-1 overflow-x-auto border-b border-charcoal-200 md:w-full", t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== activeKey || $[4] !== items || $[5] !== onChange || $[6] !== textClassName) {
    let t5;
    if ($[8] !== activeKey || $[9] !== onChange || $[10] !== textClassName) {
      t5 = t6 => {
        const {
          key,
          label,
          disabled,
          className: className_0,
          badge
        } = t6;
        return <div key={key} className={cn("flex h-full shrink-0 flex-col items-center justify-between px-3", className_0)}><button type="button" disabled={disabled} onClick={e => {
            e.preventDefault();
            if (disabled || activeKey === key) {
              return;
            }
            onChange(key);
          }} className={cn("relative flex h-full w-full items-center justify-center gap-x-2 whitespace-nowrap text-sm md:text-base", textClassName, activeKey === key ? "font-semibold text-charcoal-900" : "text-charcoal-600", disabled && "cursor-not-allowed text-charcoal-600")}>{label}{badge}</button><div className={cn(activeKey === key ? "bg-bluetiful-400" : "", "h-1 w-full rounded-t-lg")} /></div>;
      };
      $[8] = activeKey;
      $[9] = onChange;
      $[10] = textClassName;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    t4 = items.map(t5);
    $[3] = activeKey;
    $[4] = items;
    $[5] = onChange;
    $[6] = textClassName;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}